import { identityFormOptionsDefaults } from "@common/components/helpers/options/identityOptions";
import BaseReducer from "./BaseReducer";

class IdentityFormModalReducer extends BaseReducer {
  domain = "IdentityForm";
  type = "Modal";

  initialState = {
    loadingIdentityOptions: false,
    open: false,
    title: "Add person",
    hideName: false,
    optionalName: true,
    showContacts: false,
    isEditing: false,
    searchQuery: "",
    identityFormData: {
      name: null,
      dateOfBirth: null,
      gender: null,
      ageRange: null,
      height: null,
      build: null,
      hair: null,
      ethnicity: null,
      phoneNumber: "",
      emailAddress: "",
    },
    identityData: {
      id: "",
      name: "",
      features: "",
    },
    identityFormOptions: identityFormOptionsDefaults,
  };
}

const reducer = new IdentityFormModalReducer();

export default reducer;
